// extracted by mini-css-extract-plugin
export default {"link":"styles_link__V3oNp","box":"styles_box__99QO-","image":"styles_image__z1-cW"};